// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relevantset-modal-body {
  position: absolute;
  top: 20%;
  width: auto;
  /* background-color: #0d0d0d; */
  background-color: #141414;
  border-radius: 0.5vw;
  padding: 0vw;
  outline: none;
  border: none;
}

.relevantDesignPart {
  /* max-height: 410px; */
  max-height: 27.5vw;
  height: 27.5vw;

  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  /* padding: 0.2vw; */
  padding-left: 1vw;
  padding-right: 1vw;
  display: flex;
  flex-direction: column;
  gap: 1vw;
  background-color: #141414 !important;
}

.relevantDesignPart::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.apply-btn {
  font-family: Poppins;
  font-weight: 600;
  font-size: 16px;
  background-color: #50c878;
  border-bottom-right-radius: 0.5vw;
  border-bottom-left-radius: 0.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height:35px ;*/
  height: 2vw;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/CenterModal/relevantsetmoadl.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;;EAEd,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,YAAY;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,aAAa,EAAE,mBAAmB;AACpC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB","sourcesContent":[".relevantset-modal-body {\n  position: absolute;\n  top: 20%;\n  width: auto;\n  /* background-color: #0d0d0d; */\n  background-color: #141414;\n  border-radius: 0.5vw;\n  padding: 0vw;\n  outline: none;\n  border: none;\n}\n\n.relevantDesignPart {\n  /* max-height: 410px; */\n  max-height: 27.5vw;\n  height: 27.5vw;\n\n  overflow-y: auto;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE/Edge */\n  /* padding: 0.2vw; */\n  padding-left: 1vw;\n  padding-right: 1vw;\n  display: flex;\n  flex-direction: column;\n  gap: 1vw;\n  background-color: #141414 !important;\n}\n\n.relevantDesignPart::-webkit-scrollbar {\n  display: none; /* Chrome, Safari */\n}\n\n.apply-btn {\n  font-family: Poppins;\n  font-weight: 600;\n  font-size: 16px;\n  background-color: #50c878;\n  border-bottom-right-radius: 0.5vw;\n  border-bottom-left-radius: 0.5vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* height:35px ;*/\n  height: 2vw;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
